import { Component, OnInit } from "@angular/core";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs";

import { User } from "../../interfaces/user.interface";
import { selectLogon } from "../../state/selectors/user.selectors";

@Component({
    selector: "pl-status-bar",
    templateUrl: "./status-bar.component.html",
    styleUrls: ["./status-bar.component.scss"],
    standalone: false
})
export class StatusBarComponent implements OnInit {
  public user?: Partial<User>;
  public icon?: string;
  public status?: { icon: string; message: string };

  private readonly _statusList: any = {
    "--active": {
      icon: "done",
      message: "Usuário ativado",
    },
    "--pending": {
      icon: "error",
      message: "Usuário com pendência de cadastro",
    },
    "--block": {
      icon: "add_circle",
      message: "Usuário bloqueado",
    },
  };

  public details$?: Observable<any>;

  constructor(public store: Store) {
    this.details$ = this.store.select(selectLogon);
  }

  ngOnInit() {
    this._init();
  }

  private _init(): void {
    this.details$?.subscribe((user: Partial<User>) => {
      this.user = user;
      this.status = this._verifyRightStatusMessage();
    });
  }

  private _verifyRightStatusMessage() {
    const statusClass = this.user?.statusClass
      ? this.user.statusClass
      : "--default";
    return this._statusList[statusClass];
  }
}
